import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  private visibilitySubject = new BehaviorSubject<{ sidebar: boolean }>({
    sidebar: true,
  });

  visibility$ = this.visibilitySubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  // Update function with screenSize logic
  updateVisibility(sidebar: boolean): void {
    if (!isPlatformBrowser(this.platformId)) {
      // Default behavior for server-side
      this.visibilitySubject.next({ sidebar: true });
      return;
    }

    const isSmallScreen = window.outerWidth <= 900;
    if (isSmallScreen && !sidebar) {
      // If screen is small and trying to hide sidebar, keep it visible
      this.visibilitySubject.next({ sidebar: true });
    } else {
      this.visibilitySubject.next({ sidebar });
    }
  }
}